import { Stack } from '@mui/material'
import type { FC } from 'react'
import { LabelImagePreview } from './LabelImagePreview'
import { LabelSection } from './LabelSection'
import { AreaListTabs } from './areaList'

// ラベルの名前と画像の編集、検査箇所の一覧表示を行うUI
export const LabelOverview: FC = () => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
    >
      <LabelSection>
        <LabelImagePreview />
      </LabelSection>
      <Stack
        bgcolor="background.paper"
        height={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
        width={{ md: '480px' }}
        flexShrink={0}
        mb={{ xs: 2, md: 0 }}
        overflow="auto"
      >
        <AreaListTabs />
      </Stack>
    </Stack>
  )
}
